import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";
import styles from "./index.module.css";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';


export class CalendarIcon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
       
        };
        this.ref = null;
    }

    dateChanged = (val) => {
        if (!val) { return}
        if (this.props.onChange) {
            this.props.onChange(val)
        }
    }

    setDate = (val) => {
        this.ref.value = val;
    }

    render() {
        return (
            <>
                <input type="date" style={this.props.style} ref={(ref) => {this.ref=ref }} onChange={(val)=>this.dateChanged(val.target.value)} className={styles.calendarPicker}/>
            </>
        )
    }
    
}

export default CalendarIcon;


CalendarIcon.defaultProps = {
    value: null,
    onChange:null
}
